"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoader = void 0;
const Notify_1 = require("../utils/Notify");
const Netwtorking_1 = require("../utils/Netwtorking");
const MenuTopControl_1 = require("../../../app/controls/General/MenuTopControl/MenuTopControl");
const SideNavControl_1 = require("../../../app/controls/General/SideNavControl/SideNavControl");
const DOM_1 = require("../utils/DOM");
const Sentry_1 = require("../utils/Sentry/Sentry");
const ReportFeedbackControl_1 = require("../../../app/controls/General/ReportFeedbackControl/ReportFeedbackControl");
class PageLoader {
    static initializePresenterPage(welcomePage = false) {
        (0, Sentry_1.SentryInit)();
        Notify_1.Notify.Handler.processMessagesFromDOM();
        Netwtorking_1.Networking.NetworkingController.removeRequests();
        if (!welcomePage) {
            MenuTopControl_1.ControlsGeneralMenuTopControl.Control.triggerToggleMenu();
            SideNavControl_1.ControlsGeneralSideNavControl.Control.triggerToggleMenu();
            ReportFeedbackControl_1.ControlsGeneralReportFeedbackControl.Control.initialize();
            this.initRedirectTriggers();
        }
    }
    static initRedirectTriggers() {
        const redirectElements = DOM_1.DOM.Parser.getElementsByDataName('redirect-url', undefined, true);
        for (let i = 0; i < redirectElements.length; i++) {
            redirectElements[i].addEventListener('click', () => {
                window.location.href = DOM_1.DOM.Parser.getDataByNameFromElement('redirectUrl', redirectElements[i]);
            });
        }
    }
}
exports.PageLoader = PageLoader;
